import { useState, Dispatch, SetStateAction } from "react";

export default function useStateWithLS<T>(key: string, initialValue: T): [T, Dispatch<SetStateAction<T>>] {

  const [value, setValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setStoredValue: Dispatch<SetStateAction<T>> = (newValue) => {
    try {
      const valueToStore = newValue instanceof Function ? newValue(value) : newValue;

      setValue(valueToStore);
      localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.warn(`Error setting localStorage key "${key}":`, error);
    }
  };

  return [value, setStoredValue];
}
